// extracted by mini-css-extract-plugin
export default {"-large":"aU8vk8FHFfmEUCv1BoFx","panelContent":"G7QVi2bB_aWHIM3U0rYJ","blocksGrid":"ifDCabzLJkBevZyRjiZh","block":"OCCC8aT3elCeWCw_XZTp"};